import client from '../../client';

export const CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN = 'CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN';
export const EDIT_FOLLOW_UP_DATA = 'EDIT_FOLLOW_UP_DATA';
export const GET_FOLLOW_UP_DATA = 'GET_FOLLOW_UP_DATA';
export const GET_TATHATA_FOLLOW_UPS = 'GET_TATHATA_FOLLOW_UPS';
export const RESPOND_TO_FOLLOW_UP_REQUEST = 'RESPOND_TO_FOLLOW_UP_REQUEST';

export function getFollowUpData() {
  return {
    type: GET_FOLLOW_UP_DATA,
    promise: client.get('sessions/data'),
  };
}

export function editFollowUpData(values) {
  return {
    type: EDIT_FOLLOW_UP_DATA,
    promise: client.put('sessions/data', values),
  };
}

export function getTathataFollowUps() {
  return {
    type: GET_TATHATA_FOLLOW_UPS,
    promise: client.get('tathata-follow-ups'),
  };
}

export const respondToFollowUpRequest = (sessionId, values) => {
  return {
    promise: client.patch(`tathata-follow-ups/${sessionId}/respond`, values),
    type: RESPOND_TO_FOLLOW_UP_REQUEST,
  };
};

export const cancelBookedSession = (userId, sessionId, values) => {
  return {
    promise: client.patch(`tathata-follow-ups/${sessionId}/cancel`, values),
    type: CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN,
    sessionId,
  };
};



// WEBPACK FOOTER //
// ./src/follow-ups/redux/actions.js